<template>
  <div
    class="modal fade ag-modal"
    v-if="module"
    :id="module.id"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header p-0 pt-2 ag-card_navigation">
          <ul class="nav" id="ag-tab" role="tablist">
            <li
              v-for="(item, key) in module.items"
              class="nav-item"
              role="presentation"
              :key="key"
            >
              <a
                @click="getComponent(key)"
                :class="`nav-link ${key == 0 ? 'active' : ''}`"
                :id="'ag-tab_' + item.title"
                data-toggle="pill"
                :href="'#ag-tab_' + item.title"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                {{ t(item.title) }}
              </a>
            </li>
          </ul>
        </div>
        <div class="modal-body">
          <form
            v-if="
              component.type === 'ag-form' ||
              component.type === 'ag-draft-update'  ||
              component.type === 'ag-draft-review' || 
              component.type === 'ag-add-desicion'
            "
            method="post"
            @submit.prevent="submitFunction"
          >
            <component
              :is="component.type"
              :options="component.options"
            ></component>
            <div class="modal-footer">
              <button
                v-if="module.cancel"
                type="button"
                class="
                  border-0
                  ag-button ag-button_radius
                  pr-4
                  pl-4
                  ag-button_secondary
                "
                data-dismiss="modal"
              >
                {{ t(module.cancel.label) }}
              </button>
              <button
                v-if="(module.action && !module.hideAction) || (module.action && module.hideAction && module.hideAction($parent) !== true)"
                type="submit"
                class="
                  border-0
                  ag-button ag-button_radius
                  pr-4
                  pl-4
                  ag-button_primary
                  float-inline-end
                "
              >
                {{ t(module.action.label) }}
              </button>
            </div>
          </form>
          <div v-else>
            <component
              :is="component.type"
              :options="component.options"
            ></component>
          </div>
        </div>
        <div
          v-if="
            component.type !== 'ag-form' && component.type !== 'ag-draft-review' && component.type !== 'ag-add-desicion' && component.type !== 'ag-draft-update'
          "
          class="modal-footer"
        >
          <button
            v-if="module.cancel"
            type="button"
            class="
              border-0
              ag-button ag-button_radius
              pr-4
              pl-4
              ag-button_secondary
            "
            data-dismiss="modal"
          >
            {{ t(module.cancel.label) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import AgTable from "@/components/ag-table/index.vue";
import AgForm from "@/components/ag-form/index.vue";
import Customize from "@/components/ag-modal/include/Customize.vue";
import AgHashdetail from "@/components/ag-hashdetail/index.vue";
import AgHashxmldetail from "@/components/ag-hashxmldetail/index.vue";
import AgComputer from "@/components/ag-computer/index.vue";
import AgOverall from "@/components/ag-overall/index.vue";
import AgProcesstree from "@/components/ag-processtree/index.vue";
import AgHashvisibility from "@/components/ag-hashvisibility/index";
import AgScopeDetail from "@/components/ag-scope-detail/index.vue";
import AgDraftReview from "@/components/ag-draft-review/index.vue";
import AgDraftUpdate from "@/components/ag-draft-update/index.vue";
import AgAlertDetail from "@/components/ag-alert-detail/index.vue";
import AgEventList from "@/components/ag-event-list/index.vue";
import AgAuditDetail from "@/components/ag-audit-detail/index.vue";
import AgXmlDetail from "@/components/ag-xml-detail/index.vue";
import AgAncestorList from "@/components/ag-ancestor-list/index.vue";
import AgEventCountList from "@/components/ag-event-count-list/index.vue";
import AgAddDesicion from "@/components/ag-add-desicion/index.vue";
import AgEventPolicy from "@/components/ag-event-policy/index.vue";

export default defineComponent({
  name: "ag-modal",
  data() {
    return {
      component: {},
    };
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  created() {
    this.getComponent(0);
  },
  props: {
    module: {
      type: Object,
      default: null,
    },
  },
  components: {
    AgTable,
    AgForm,
    Customize,
    AgHashdetail,
    AgHashxmldetail,
    AgComputer,
    AgOverall,
    AgProcesstree,
    AgHashvisibility,
    AgScopeDetail,
    AgDraftReview,
    AgAlertDetail,
    AgEventList,
    AgAuditDetail,
    AgXmlDetail,
    AgAncestorList,
    AgDraftUpdate,
    AgEventCountList,
    AgAddDesicion,
    AgEventPolicy
  },
  methods: {
    submitFunction(e) {
      this.module.action.function(this.component);
      e.preventDefault();
    },
    getComponent(index) {
      let selectedData = this.module.items[index];
      if (selectedData) {
        this.component.type = selectedData.component;
        this.component.options = selectedData.options;
      }
    },
  },
});
</script>

<style scoped></style>
